import React from "react"

const Connector2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    width="60"
    height="200"
    viewBox="0 0 60 200"
  >
    <g id="Group_158" data-name="Group 158" transform="translate(-476 -1649)">
      <g
        id="Ellipse_11"
        data-name="Ellipse 11"
        transform="translate(476 1649)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      >
        <circle cx="7" cy="7" r="7" stroke="none" />
        <circle cx="7" cy="7" r="6.5" fill="none" />
      </g>
      <g
        id="Ellipse_12"
        data-name="Ellipse 12"
        transform="translate(476 1694)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      >
        <circle cx="7" cy="7" r="7" stroke="none" />
        <circle cx="7" cy="7" r="6.5" fill="none" />
      </g>
      <g
        id="Ellipse_15"
        data-name="Ellipse 15"
        transform="translate(476 1740)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      >
        <circle cx="7" cy="7" r="7" stroke="none" />
        <circle cx="7" cy="7" r="6.5" fill="none" />
      </g>
      <g
        id="Ellipse_13"
        data-name="Ellipse 13"
        transform="translate(476 1785)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      >
        <circle cx="7" cy="7" r="7" stroke="none" />
        <circle cx="7" cy="7" r="6.5" fill="none" />
      </g>
      <path
        id="Path_7203"
        data-name="Path 7203"
        d="M0,0V32"
        transform="translate(483.5 1662.5)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      />
      <path
        id="Path_7205"
        data-name="Path 7205"
        d="M0,0V32"
        transform="translate(483.5 1708.5)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      />
      <path
        id="Path_7206"
        data-name="Path 7206"
        d="M0,0V43H39.523"
        transform="translate(483.5 1798.5)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      />
      <path
        id="Path_7207"
        data-name="Path 7207"
        d="M0,0V32"
        transform="translate(483.5 1753.5)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      />
      <g
        id="Ellipse_16"
        data-name="Ellipse 16"
        transform="translate(522 1835)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
      >
        <circle cx="7" cy="7" r="7" stroke="none" />
        <circle cx="7" cy="7" r="6.5" fill="none" />
      </g>
    </g>
  </svg>
)

export default Connector2
